<template>
    <button :class="classes" :href="href" @click.stop="onClick"
    id="phone-button"
    >
        <svg v-if="hideText" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0376 5.31642L10.6866 6.47934C11.2723 7.52883 11.0372 8.90557 10.1147 9.82804C10.1147 9.82805 10.1147 9.82804 10.1147 9.82805C10.1146 9.82816 8.99588 10.9471 11.0245 12.9757C13.0525 15.0037 14.1714 13.8863 14.1722 13.8855C14.1722 13.8855 14.1722 13.8855 14.1722 13.8855C15.0947 12.9631 16.4714 12.7279 17.5209 13.3136L18.6838 13.9627C20.2686 14.8471 20.4557 17.0695 19.0628 18.4624C18.2258 19.2994 17.2004 19.9507 16.0669 19.9937C14.1588 20.066 10.9183 19.5831 7.6677 16.3325C4.41713 13.082 3.93421 9.84147 4.00655 7.93333C4.04952 6.79984 4.7008 5.77448 5.53781 4.93748C6.93076 3.54453 9.15317 3.73168 10.0376 5.31642Z" fill="currentColor"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-1 mr-sm-2" width="18" height="18">
            <path fill-rule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clip-rule="evenodd"></path>
        </svg>
        <span v-if="buttonText" v-html="buttonText"></span>
    </button>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import Url from "domurl";
import analyticsMixin from "./mixins/analytics-mixin";

export default {
    props: {
        number: {
            type: String,
            required: true
        },
        telephoneId: {
            type: [String, Number],
            required: true
        },
        postId: {
            type: [String, Number],
            required: true
        },
        postPublicId: {
            type: [String, Number],
            required: true
        },
        callsCounterUrl: {
            type: String,
            required: true
        },
        pageType: {
            type: String,
            required: false,
            default: null,
        },
        pageNumber: {
            type: [String, Number],
            required: false,
            default: null
        },
        enableShowNumberListener: {
            type: Boolean,
            default: false
        },
        isDetailView: {
            type: Boolean,
            default: false
        },
        hideText: {
            type: Boolean,
            default: false
        },
        showPhoneText: {
            type: Boolean,
            default: false
        }
    },
    mixins: [analyticsMixin],
    data() {
        return  {
            ignoreClick: false,
            eventName: 'phone-button:show-telephone-number',
            text: ''
        };
    },
    computed: {
        classes() {
            return {
                "btn-phone-disabled w-auto px-3": this.ignoreClick && this.pageType === 'listing',
            };
        },
        buttonText() {
            if (this.text === this.number) {
                if (this.number.length >= 3) {
                    return `${this.number.slice(0, 3)}&#8203;${this.number.slice(3)}`;
                }
                return this.number;
            }

            return this.text;
        },
        href() {
            return  `tel:${this.number}`
        },
    },
    created: function() {
        if (this.pageType !== 'detail') {
            this.text = "";
            return;
        }

        if (this.showPhoneText){
           return this.text = this.number;
        }

        this.$root.isMobile ? this.text = gettext("call me") : this.text = gettext("telephone");
    },
    mounted: function() {
        if(this.enableShowNumberListener) {
            window.addEventListener(this.eventName, this.showTelephoneNumber);
        }
    },
    beforeDestroy() {
        if(this.enableShowNumberListener) {
            window.removeEventListener(this.eventName, this.showTelephoneNumber);
        }
    },
    methods: {
        showTelephoneNumber(event) {
          if(!event.detail.mobile && event.detail.number === this.number){
              this.text = this.number;
              this.ignoreClick = true;
          }
        },
        onClick() {
            if(this.ignoreClick) {
                // ignore multiple clicks in non-mobile browsers
                return;
            }

            // analytics
            this.contactButtonAnalytics(this.isDetailView, this.postPublicId, 'tel');

            // send event to other buttons
            const isMobile = window.app.isMobile;

            if(!isMobile || this.text.indexOf('...') > 0){
                this.ignoreClick = true;
                this.text = this.number;
                let event = new CustomEvent(this.eventName, {detail: {number: this.number, mobile: isMobile}});
                window.dispatchEvent(event);
                if (!this.showTelephoneNumber) return this.showTelephoneNumber(event);
            }

            // save current url
            const url = new Url(window.location.href);

            // open link on mobile devices only
            if(isMobile) {
                window.location.href = this.href;
            }

            // increase calls click counter
            this.$http.post(
                this.callsCounterUrl,
                {
                    id: this.telephoneId,
                    post: this.postId,
                    ct: 'telephone',
                    pt: this.pageType,
                    rs: url.query.source || null, // referer source
                    rp: url.query.page || this.pageNumber || null, // page (referer or listing)
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            ).catch(console.error);
        }

    }
};
</script>
<style>
@media (max-width: 768px) {
  #phone-button {
    white-space: nowrap;
  }
}
</style>
